import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useAuth } from '../../contexts/AppContext';
import { Input } from '../../components/shared/Input';
import { ActionButton } from '../../components/shared/ActionButton';
import { useToaster } from '../../components/shared/Toaster';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { addToast } = useToaster();
  const [email, setEmail] = useState('admin@mybudget.local');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      addToast({ type: 'success', message: 'Login realizado com sucesso!' });
      navigate('/');
    } catch (err) {
      addToast({
        type: 'error',
        message: err instanceof Error ? err.message : 'Erro ao fazer login',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-dark-bg px-4">
      <div className="pointer-events-none absolute inset-0 bg-gradient-radial from-accent/10 via-transparent to-transparent" />
      <div className="relative w-full max-w-md rounded-2xl border border-dark-border bg-dark-surface/90 p-6 shadow-2xl backdrop-blur sm:p-8">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent/15">
            <AccountBalanceWalletIcon className="text-accent" fontSize="large" />
          </div>
          <h1 className="text-2xl font-bold text-gray-100">MyBudget</h1>
          <p className="mt-2 text-sm text-gray-400">
            Controle salário, despesas e projeções mensais
          </p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input
            label="E-mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
          <Input
            label="Senha"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <ActionButton type="submit" loading={loading} className="mt-2 w-full">
            Entrar
          </ActionButton>
        </form>
      </div>
    </div>
  );
}
